<div class="col-xs-12">
    <h1>Clients List  <input (click)="addClient()" type="button" class="btn btn-add-client btn-primary"
            value="Add Client" />
            <input *ngIf="tokensEnabled && !showTokens" type="button" class="btn btn-secondary" 
            (click)="showTokens = true"
            value="Show Tokens" />
            <input *ngIf="tokensEnabled && showTokens" type="button" class="btn btn-secondary" 
            (click)="showTokens = false"
            value="Hide Tokens" />
        </h1>    
    <dac-assessment-tokens-list *ngIf="showTokens" class="mb-5"></dac-assessment-tokens-list>
    <!-- <search-input (search)="doSearch($event)" (reset)="resetSearch()" [initialSearch]="lastSearchValue" class="mb-2"></search-input> -->
    <form #searchForm="ngForm" class="form-horizontal">
        <div class="search row">
            <div class="col">
                <input type="text" class="form-control" [ngClass]="{'text-red':searchByNameInvalid}"
                    placeholder="First name..." [(ngModel)]="searchFirstName" #firstName name="firstName" (keyup.enter)="doSearch()">
            </div>
            <div class="col">
                    <div class="input-group">
                        <input type="text" class="form-control" [ngClass]="{'text-red':searchByNameInvalid}"
                            placeholder="Last name..." (keyup.enter)="doSearch()" [(ngModel)]="searchLastName" #lastName name="lastName">
                        <span class="input-group-btn">
                            <button class="btn btn-primary" type="button" (click)="doSearch()">Search</button>
                            
                            <button type="button" class="btn btn-secondary" (click)="resetSearch()">
                                <i class="fa fa-refresh" aria-hidden="true" aria-label="Reset" ></i></button>
                        </span>
                    </div>
                </div>
        </div>
        <div class="row">
            <div class="col">
                    <small [ngClass]="{'alert alert-danger text-bold': searchByNameInvalid}">The first four letters of the last name and the first letter of the first name is required to search. 
                        Last names less than four characters will only return exact matches for the last name.</small>
            </div>
        </div>
        <div class="row mb-2 mt-2">
            <details class="col">
                <summary>Advanced Search Options<i class='fa fa-question-circle-o' mdbTooltip="Click here to show advanced search filters such as showing the clients for all of the users in your company" placement="top" mdbWavesEffect></i></summary>
                <div class="row" *hasPermission="'Admin'">
                    <div class="col">
                        <input id="showAllUsers"type="checkbox" (click)="toggleAllUsers()" [checked]="showAllUsers" name="showAllUsers" />
                        <label for="showAllUsers">Show all clients for all users in your organization</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input id="exactMatch" type="checkbox" (click)="toggleExactMatch()" [checked]="exactMatch" name="exactMatch" />
                        <label for="exactMatch">Only show results that match fields exactly.</label>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <input type="text" class="form-control"
                            placeholder="Search by Unique ID..." [(ngModel)]="searchClientID" #clientID="ngModel" name="clientID">
                    </div>
                    <div class="col">
                        <input type="text" class="form-control"
                            placeholder="Search by Exact Email..." [(ngModel)]="searchEmail" (keyup.enter)="doSearch()" #clientID="ngModel" name="searchEmail">
                    </div>
                </div>
            </details>
        </div>
    </form>
    <p class="alert alert-info" *ngIf="!isSearching && Clients.length == 0">No clients found.  Either adjust your search or add a new client!</p>
    <div class="clientList" *ngIf="Clients.length"> 
        <div class="row list-group-item primary-gradient p-3 text-light">
            <div class="col-12">
                <div class="row"> 
                    <div [ngClass]="{'col-6': !showAllUsers, 'col-4':showAllUsers}">Client 
                            <i class='fa fa-question-circle-o' mdbTooltip="This is your client profile" placement="right" mdbWavesEffect></i>
                    </div>
                    <div *ngIf="showAllUsers" class="col-2">Assigned User</div>
                    <div class="col-2">Date Assigned <i class='fa fa-question-circle-o' mdbTooltip="The date a battery or single assessment was assigned." placement="right" mdbWavesEffect></i></div>
                    <div class="col-2">Completed<i class='fa fa-question-circle-o' mdbTooltip="The number of individual assessments a client has completed out of the total number they have assigned" placement="right" mdbWavesEffect></i></div>
                    <div class="col-2 text-center">Action</div>
                </div>
            </div>
        </div>
        <div class="row list-group-item" *ngFor="let client of Clients">
            <div class="col-12"> 
                <div class="row">
                    <div [ngClass]="{'col-6': !showAllUsers, 'col-4':showAllUsers}">
                        <h4 class="d-inline"><i class="fa fa-user pr-2"></i></h4>{{client.getDisplayString()}}
                        <h6><i class="fa fa-key pt-2 pr-2 h4-responsive"></i>{{client.getDisplayId()}}</h6>
                        <h6 *ngIf="client.email"><i class="fa fa-envelope pr-2 h4-responsive"></i>{{client.email}}</h6>
                    </div>
                    <div *ngIf="showAllUsers" class="col-2">{{client.user?.getDisplayName()}}</div>
                    <div class="col-2"></div>
                    <div class="col-2">
                    </div>
                    <div class="col-2 text-center">
                            <button type="button" class="btn btn-primary" [routerLink]="['../',client.id]">
                                View
                            </button>
                    </div>
                </div>
            </div>
            <div class="col-12" *ngIf="client.assignments.length == 0">
                    <div class="row mb-2">
                            <div class="col-6 pl-5" >
                                No assessments assigned.
                            </div>
                        </div>
            </div>
            <div class="col-12" *ngFor="let assignment of client.assignments">
                    <div class="row mb-2">
                        <div class="col-6 pl-5" >
                            <i class="fa fa-clipboard" *ngIf="assignment.type=='Assessment'"></i>
                            <i class="fa fa-file-text" *ngIf="assignment.type=='LibraryAsset'"></i>
                            <i class="fa fa-folder" *ngIf="assignment.type=='AssessmentGroup'"></i>
                            {{assignment.Name}}
                        </div>
                        <div class="col-2">{{assignment.DateAssigned|date:'mediumDate'}}</div>
                        <div class="col-2">
                            <span *ngIf="assignment.IsComplete">{{assignment.DateCompleted|date:'mediumDate'}} - {{assignment.getAssignmentsCompleted()}}/{{assignment.getTotalAssignments()}}</span>
                            <span *ngIf="!assignment.IsComplete">Incomplete - {{assignment.getAssignmentsCompleted()}}/{{assignment.getTotalAssignments()}}</span>
                        </div>
                        <div class="col-2">
                        </div>
                    </div>
            </div>
        </div>
    </div>
    <div class="row" *ngIf="hasMoreResults() || isSearching">
        <div class="col">
            <button class="btn btn-primary" (click)="loadMore()" [disabled]="isSearching">
                <span *ngIf="!isSearching">Load More</span>
                <span *ngIf="isSearching">Loading...</span>
            </button>
            <app-spin-icon *ngIf="isSearching"></app-spin-icon>
        </div>
    </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/client-list/client-list.component.html